export default __webpack_public_path__ + "static/media/pxgroup08.a3c00a41.png";